<app-referrals-ehr-listing
  [loading]="loadingReferralMatchOptions"
  [editable]="editable"
  [patientPrescriber]="patientPrescriber"
  [provider]="capture.provider"
  [referralMatchOptions]="referralMatchOptions"
  (newEhrReferralVerification)="onNewEhrReferralVerification($event)"
  (ehrReferralVerificationEdited)="onEhrReferralVerificationEdited($event)"
  (referralVerificationChange)="onReferralVerificationChange($event)" />
